import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import firebase from "firebase";
import {
  ClassroomContainer,
  ClassroomBody,
  ClassroomNav,
  FormButton
} from "./Classroom";
import Draggable from "react-draggable";

import { TimelineData } from "./TimelineData";

const COLORS = {
  EARLY: "#fffb84",
  ACTIVE: "#ffd561",
  TRANSITIONING: "#ff7863",
  PUSHING: "#a4d770",
  "BABY IS HERE": "#553866"
};

const ZoomFrame = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;

  z-index: 100;
  overflow: auto;
`;

const ZoomPlane = styled.div`
  position: absolute;
  transform-origin: 0 0;
  transform: scale(${({ zoom }) => zoom});
  width: 5000px;
  height: 5000px;
`;

const BoardGrid = styled.div`
  position: absolute;
  left: 500px;
  top: 1000px;
  height: 3000px;
  width: 4000px;
  display: grid;
  grid-template-columns: 20fr 12fr 6fr 7fr 5fr;
`;

const BoardSlot = styled.div`
  background-color: ${({ title }) => COLORS[title]};
  display: flex;
  align-items: flex-start;
  font-size: 48px;
  padding: 24px;
  justify-content: center;
  font-family: var(--title);
`;

const Card = styled.div`
  width: 300px;
  height: 300px;
  font-size: 30px;
  padding: 4px;
  background-color: var(--gold);
  color: var(--blue);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 2;
  font-family: var(--body);
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
`;

function DraggableCard({ text, zoom }) {
  const [{ x, y }, setCoordinates] = useState({ x: 0, y: 0 });
  useEffect(() => {
    function doSetCoordinates(snapshot) {
      const { x, y } = snapshot.val() ?? { x: 0, y: 0 };
      setCoordinates({ x, y });
    }
    firebase
      .database()
      .ref(`/timeline/${text}`)
      .on("value", doSetCoordinates);

    return () =>
      firebase
        .database()
        .ref(`/timeline/${text}`)
        .off("value", doSetCoordinates);
  }, [text]);

  return (
    <Draggable
      onDrag={(_, { x, y }) => {
        firebase
          .database()
          .ref(`timeline/${text}`)
          .set({ x, y });
        setCoordinates({ x, y });
      }}
      position={{ x: x ?? 0, y: y ?? 0 }}
      scale={zoom}
    >
      <Card key={text}>{text}</Card>
    </Draggable>
  );
}

export function Timeline() {
  const [zoom, setZoom] = useState(1);
  const paneRef = useRef();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    function doSetWindowWidth() {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", doSetWindowWidth, false);
    return () => window.removeEventListener("resize", doSetWindowWidth, false);
  }, []);

  return (
    <ClassroomContainer>
      <ClassroomNav backToClassroom={true}>
        <FormButton
          onClick={() => {
            setZoom(z => Math.max(1, z - 1));
          }}
        >
          ZoomOut
        </FormButton>
        <FormButton
          onClick={() => {
            const el = paneRef.current;
            const plane = el.children[0];
            console.log(plane.clientWidth);
            console.log(el);
            el.scrollTo(el.scrollWidth * (2 / 5), el.scrollHeight * (3 / 10));
          }}
        >
          Center
        </FormButton>
        <FormButton
          onClick={() => {
            setZoom(z => Math.min(10, z + 1));
          }}
        >
          ZoomIn
        </FormButton>
      </ClassroomNav>
      <ClassroomBody>
        <ZoomFrame ref={paneRef}>
          <ZoomPlane zoom={(windowWidth / 5000) * zoom}>
            <BoardGrid>
              {Object.keys(COLORS).map(title => (
                <BoardSlot key={title} title={title}>
                  {title}
                </BoardSlot>
              ))}
            </BoardGrid>
            {TimelineData.map(({ text }) => {
              return (
                <DraggableCard
                  key={text}
                  text={text}
                  zoom={(windowWidth / 5000) * zoom}
                />
              );
            })}
          </ZoomPlane>
        </ZoomFrame>
      </ClassroomBody>
    </ClassroomContainer>
  );
}
